export default class AppliedFacets {
    constructor() {
        this.addAppliedFacetsInputs();
    }
    addAppliedFacetsInputs() {
        const searchFields = document.querySelectorAll('.quick-search__input');
        const appliedFacetContainer = document.querySelector('.facet__list--applied');

        searchFields.forEach(searchField => {
            const appliedFilterKeys = appliedFacetContainer.querySelectorAll('.applied-filter-key');
            appliedFilterKeys.forEach(filterKey => {
                // Cloning the hidden input elements to move them in all quick search fields
                const filterClone = filterKey.cloneNode(true);
                searchField.appendChild(filterClone);
            });
        });
    }
}
